__turbopack_context__.v({
  "alert-banner": "password-protected-course-module-scss-module__-RRQvW__alert-banner",
  "form-group": "password-protected-course-module-scss-module__-RRQvW__form-group",
  "title": "password-protected-course-module-scss-module__-RRQvW__title",
});
